import { api } from './apiSlice'

export const sessionsApiSlice = api.injectEndpoints({
  endpoints: build => ({
    querySessions: build.query({
      query: subjectId => `/sessions?subjectId=${encodeURIComponent(subjectId)}`,
      providesTags: (result, error, subjectId) => [{ type: 'UserSessions', id: subjectId }],
    }),
    revokeAllSessions: build.mutation({
      query: body => ({ url: '/sessions/revoke-all', method: 'POST', body }),
      invalidatesTags: (result, error, body) => [{ type: 'UserSessions', id: body.subjectId }],
    }),
    setBackChannelLogoutUri: build.mutation({
      query: ({ clientId, backChannelLogoutUri }) => ({
        url: `/clients/${clientId}/backchannel-logout-uri`,
        method: 'PUT',
        body: { backChannelLogoutUri },
      }),
      invalidatesTags: (result, error, { clientId }) => [{ type: 'ClientBackChannelLogout', id: clientId }],
    }),
    getBackChannelLogoutUri: build.query({
      query: clientId => `/clients/${clientId}/backchannel-logout-uri`,
      providesTags: (result, error, clientId) => [{ type: 'ClientBackChannelLogout', id: clientId }],
    }),
  }),
})

export const {
  useQuerySessionsQuery,
  useRevokeAllSessionsMutation,
  useSetBackChannelLogoutUriMutation,
  useGetBackChannelLogoutUriQuery,
} = sessionsApiSlice
